export function checkForNestedRoute(obj, level, ...rest) {
    if (obj === undefined) return false;
    if (rest.length === 0 && obj.hasOwnProperty(level)) return obj[level];
    return checkForNestedRoute(obj[level], ...rest);
}

export const ROUTE_PARENT = "morpheus.routes";
